import { createFileRoute } from "@tanstack/react-router";
import { RouteGuard } from "@/components/RouteGuard";
import { UtmBuilder } from "@/lib/lazyPages";

export const Route = createFileRoute("/admin/utm-builder")({
  component: () => (
    <RouteGuard access={{ kind: "admin" }}>
      <UtmBuilder />
    </RouteGuard>
  ),
});
